<template>
  <div class="container">
    <Head title="Dashboard" />
    <!--    <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>-->
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/">Dashboard /</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="columns is-centered">
      <div class="column">
        <div class="panel has-text-centered">
          <card-component title="Verticals">
            <growing-number :duration="growingNumberDuration" class="is-size-3" :value="verticals" />
          </card-component>
        </div>
      </div>
      <div class="column">
        <div class="panel has-text-centered">
          <card-component title="Markets">
            <growing-number :duration="growingNumberDuration" class="is-size-3" :value="markets" />
          </card-component>
        </div>
      </div>
      <div class="column">
        <div class="panel has-text-centered">
          <card-component title="Sector Targets">
            <growing-number :duration="growingNumberDuration" class="is-size-3" :value="sectorTargetCount" />
          </card-component>
        </div>
      </div>
    </div>

<!--    I'll add in some helpful charts here. Not sure what they need to be yet. Will get some ideas in our next meeting-->
    <section class="section">
      <div class="columns">
        <div class="column">
          <card-component title="Leads Per Day">
            <line-chart :height="200" :chart-id="'LeadsPerDay'" :chart-data="leadsByDateChart" :chart-options="leadsByDateChartOptions"/>
          </card-component>
        </div>
        <div class="column">
          <card-component title="Leads by Sector Target">
            <bar-chart :height="200" :chart-id="'LeadsBySectorTarget'" :chart-data="leadsBySTChart" :chart-options="leadsBySTChartOptions"/>
          </card-component>
        </div>
      </div>
    </section>

    <div class="panel">
      <h2 class="p-2 mb-8 is-size-4 has-text-weight-bold">Sector Targets</h2>
      <card-component>
        <b-table
          striped
          backend-filtering
          backend-pagination
          backend-sorting
          :data="sectorTargets.data"
          @sort="onSort"
        >
          <b-table-column label="Market" sortable field="market">
            <template #default="{row}">
              <Link :href="`/sector-targets/${row.id}`">{{ row.market.city }}, {{ row.market.state }}</Link>
            </template>
          </b-table-column>

          <b-table-column label="Vertical" sortable field="vertical">
            <template #default="{row}">
              <Link :href="`/sector-targets/${row.id}`">{{ row.vertical.name }}</Link>
            </template>
          </b-table-column>

          <b-table-column v-slot="{ row }" label="Created" sortable field="created_at">
            {{ row.created_at | moment }}
          </b-table-column>

<!--          <b-table-column v-slot="{ row }" label="Created" sortable field="created_at">-->
<!--            {{ row.created_at | moment }}-->
<!--          </b-table-column>-->

        </b-table>

        <!--      <laravel-pagination :data="sectorTargets" :filters="filters"></laravel-pagination>-->
      </card-component>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue2'
import Layout from '@/Shared/Layout'
import GrowingNumber from '@/Shared/GrowingNumber.vue'
import debounce from 'lodash/debounce'
import _ from 'lodash'
import CardComponent from '@/Shared/CardComponent.vue'
import LineChart from "@/Shared/Charts/LineChart.vue";
import BarChart from "@/Shared/Charts/BarChart.vue";


export default {
  components: {
    LineChart,
    BarChart,
    CardComponent,
    GrowingNumber,
    Head,
  },
  props: {
    verticals: null,
    markets: null,
    sectorTargetCount: null,
    sectorTargets: null,
    leadsByDate: null,
    leadsBySectorTarget: null
  },
  data() {
    return {
      growingNumberDuration: 1000,
      leadsBySTChartOptions: {
        scales: {
          y: {
            min: 0,
            ticks: {
              stepSize: 1
            }
          }
        }
      },
      leadsByDateChartOptions: {
        scales: {
          y: {
            min: 0,
            ticks: {
              stepSize: 1
            }
          }
        }
      }
    }
  },
  computed: {
    leadsByDateChart() {
      return {
        labels: Object.keys(this.leadsByDate),
        datasets: [
          {data: Object.values(this.leadsByDate)},
        ]
      }
    },
    leadsBySTChart() {
      return {
        labels: Object.keys(this.leadsBySectorTarget),
        datasets: [
          {
            label: 'Leads',
            data: Object.values(this.leadsBySectorTarget)
          },
        ]
      }
    },
  },
  methods: {
    update: debounce(function(filters) {
      this.$inertia.get(this.sectorTargets.path, {
        ..._.merge(this.filters, filters),
        page: this.sectorTargets.current_page,
      }, {
        preserveState: true,
        replace: true,
      })
    }, 300),
    onSort(field, order) {
      this.update({ sort_field: field, sort_order: order})
    },
  },
  layout: Layout,
}
</script>
